import {
  proactiveAgentNames,
  myProactiveAgentNames,
  resolveSelectedProactiveAgent,
} from '@/features/home/proactive-agent-visibility';
import { useIsInternalUser } from '@/hooks/useIsInternalUser';
import { settingsStore } from '@/stores/settings.store';

import type { ProactiveAgents } from './proactive-agent.query';

/**
 * Home follows My agents unless this device pins one agent or no agents.
 * `followsDefault` means no device pin is in effect. `homeFiltersByAgent` is
 * false while home shows every card, whichever agent is chosen: for a user who is not internal, or
 * with the internal view off on this device.
 */
export const useProactiveAgentSelection = (
  agents: ProactiveAgents | undefined
) => {
  // React Compiler would cache the settings store read and miss its changes
  'use no memo';
  const isInternalUser = useIsInternalUser();
  const instances = agents?.instances ?? [];
  const names = proactiveAgentNames(agents?.startable_agents ?? [], instances);
  const selectedAgent = resolveSelectedProactiveAgent(
    settingsStore.selectedProactiveAgent,
    names,
    instances,
    agents?.default_agent
  );
  const followsDefault = selectedAgent !== settingsStore.selectedProactiveAgent;
  const selectedAgents = followsDefault
    ? agents
      ? myProactiveAgentNames(agents)
      : []
    : selectedAgent === 'none'
      ? []
      : [selectedAgent];
  return {
    instances,
    names,
    selectedAgent: followsDefault
      ? (selectedAgents[0] ?? 'none')
      : selectedAgent,
    followsDefault,
    selectedAgents,
    homeFiltersByAgent:
      isInternalUser && settingsStore.internalProactiveAgentView,
  };
};
